import { ICompany } from "@models";
import http from "../http-common";

/**
 * Retrieves company information based on the provided ID.
 *
 * @param {any} id - The ID of the company to retrieve information for
 * @return {Promise<ICompany>} A promise that resolves with the company information
 */
const getInfo = (id: string) => {
  return http.get<ICompany>(`optout/${id}/info`);
};
const submitForm = (id: string, data: any) => {
  return http.post<any>(`optout/${id}/message`, data);
};
const optoutLink = (id: string, data: any) => {
  return http.post<any>(`optout/${id}/revoked`, data);
};

const OptOutFormService = {
  getInfo,
  submitForm,
  optoutLink,
};

export default OptOutFormService;
